import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useFindSuccess } from 'hooks/useFindSuccess';
import { useFindError } from 'hooks/useFindError';
import { useFindLoad } from 'hooks/useFindLoad';
import { LoadingButton } from 'components/buttons';
import { yupResolver } from '@hookform/resolvers/yup';
import { emailValidationSchema } from 'validationSchemes/emailValidationSchema';
import { authActions, SOCIAL_LOGIN_EMAIL_VERIFICATION } from 'store/auth';
import { loginProvider } from 'components/socialLogin/types';
import { getStorage } from 'utils/storageHelpers';
import { ROUTES } from 'utils/routeNames';
import { Images } from 'assets/images';
import {
  CloseModal,
  EmailModal,
  ModalContainer,
  ForgotPasswordBlock,
} from './styled';
import {
  CloseIcon,
  ForgotPasswordForm,
  InputEmail,
  InputEmailAndSendButtonBlock,
  ModalDescription,
  TitleOfPage,
  CloseIconLink,
  ErrorMessage,
  StyledButtonContainer,
} from 'containers/Auth/forgotPassword/styled';

export const EditEmailModal = ({ setShowEmailModal }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const success = useFindSuccess(SOCIAL_LOGIN_EMAIL_VERIFICATION);
  const errorEmail = useFindError(SOCIAL_LOGIN_EMAIL_VERIFICATION);
  const isLoading = useFindLoad(SOCIAL_LOGIN_EMAIL_VERIFICATION);

  const closeModal = () => setShowEmailModal(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(emailValidationSchema),
  });

  const submit = (data) => {
    const { email } = data;
    const body = {
      email,
      provider: loginProvider.facebook,
      accessToken: getStorage('fbAccessToken'),
    };

    dispatch(authActions.socialLoginEmailVerification(body));
  };

  useEffect(() => {
    if (success.length) {
      closeModal();
      navigate(ROUTES.VERIFY_EMAIL);
    }
  }, [success.length]);

  return (
    <EmailModal>
      <CloseModal />
      <ModalContainer>
        <ForgotPasswordBlock>
          <ForgotPasswordForm autoComplete="off" onSubmit={handleSubmit(submit)}>
            <TitleOfPage>Enter email</TitleOfPage>

            <CloseIconLink to={ROUTES.LOGIN} onClick={closeModal}>
              <CloseIcon src={Images.closeBlueIcon} />
            </CloseIconLink>

            <ModalDescription>
              Enter your email address, and we'll send you a verification code
            </ModalDescription>

            <InputEmailAndSendButtonBlock>
              <InputEmail
                autoComplete="off"
                type="text"
                {...register('email')}
                placeholder="Enter Email Address"
                error={errors.email?.message || errorEmail[0]}
              />
              <ErrorMessage>
                {errorEmail[0] ? t('emailNotValid') : errors.email?.message}
              </ErrorMessage>
              <StyledButtonContainer>
                <LoadingButton
                  width="100%"
                  height="54px"
                  fs="20px"
                  loading={isLoading}
                  name="Send"
                  type="submit"
                />
              </StyledButtonContainer>
            </InputEmailAndSendButtonBlock>
          </ForgotPasswordForm>
        </ForgotPasswordBlock>
      </ModalContainer>
    </EmailModal>
  );
};
